import {
  PUT_LOCATIONS_CATALOG,
  PUT_LOCATIONS_CATALOG_SUCCESS,
  PUT_LOCATIONS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putLocationsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case PUT_LOCATIONS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_LOCATIONS_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_LOCATIONS_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
